import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DataTable from '../DataTable';
import PaginationBar from '../PaginationBar';
import usePagination10 from '../hooks/usePagination10';

function VinculosEntidadeModal({ show, entidade, onClose }) {
  const [vinculos, setVinculos] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (show && entidade && entidade.idEntidade) {
      setLoading(true);
      axios
        .get(`${API_BASE_URL.VINCULO}/cnpj`, {
          params: { idEntidade: entidade.idEntidade },
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => {
          setVinculos(result.data);
        })
        .catch(error => {
          console.error('Erro ao obter vinculos:', error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setVinculos([]);
    }
  }, [show, entidade, token]);

  const totalItems = vinculos.length;
  const { setPagination } = usePagination10(totalItems);
  const displayedVinculos = vinculos.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  if (!show) return null;

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" style={{ height: '90vh' }}>
          <div className="modal-content" style={{ height: '90vh' }}>
            <div
              className="modal-header py-2"
              style={{
                background:
                  'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
                color: '#fff',
              }}
            >
              <h6 className="modal-title mb-0">
                <i className="bi bi-link-45deg me-2"></i>
                Vínculos
              </h6>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="card mb-3">
                <div className="card-body py-2 px-3">
                  <h6 className="card-title mb-0">
                    <i className="bi bi-building me-2"></i>
                    {entidade?.nome || '-'}
                  </h6>
                </div>
              </div>
              {isLoading ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando...</span>
                  </div>
                </div>
              ) : vinculos.length > 0 ? (
                <div style={{ fontSize: '0.8rem' }}>
                  <DataTable
                    head={
                      <tr>
                        <th>Usuário</th>
                        <th>CPF</th>
                        <th>Tipo de Vínculo</th>
                        <th>Situação</th>
                      </tr>
                    }
                  >
                    <tbody>
                      {displayedVinculos.map(v => (
                        <tr key={`${v.idEntidade}-${v.cpf}`}>
                          <td>{v.usuario?.nome || '-'}</td>
                          <td>{v.cpf}</td>
                          <td>{v.tipo}</td>
                          <td>{v.situacao || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </DataTable>
                </div>
              ) : (
                <div className="text-center text-muted py-4">
                  <i className="bi bi-inbox" style={{ fontSize: '2rem' }}></i>
                  <p className="mt-2">Nenhum vínculo encontrado.</p>
                </div>
              )}
            </div>
            <div style={{ padding: '0.5rem 1rem', borderTop: '1px solid rgba(0,0,0,0.1)', backgroundColor: '#f8f9fa' }}>
              <PaginationBar setPagination={setPagination} />
            </div>
            <div className="modal-footer py-2">
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={onClose}
              >
                <i className="bi bi-x-lg me-1"></i>Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VinculosEntidadeModal;
